<template>
  <div>
    <base-button block type="primary" class="m-0" @click="modal = true">
      {{ $t('operators.create.btnLabel') }}
    </base-button>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('operators.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('operators.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('generic.id') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'identifier'"
                name="id"
                v-validate="modelValidations.required"
                :error="getError('id')"
                v-model="formDetails.id">
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('operators.details.name') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'name'"
                name="name"
                v-validate="modelValidations.required"
                :error="getError('name')"
                v-model="formDetails.name">
              </base-input>
            </div>
          </div>

          <!-- type select -->
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('generic.type') }}</label>
            <div class="col form-group">
                <el-select
                  class="select-primary"
                  name="role"
                  v-model="formDetails.type"
                >
                  <el-option
                    v-for="option in availableTypes"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="option"
                  >
                  </el-option>
                </el-select>
            </div>
          </div>

          <!-- status select -->
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('generic.status') }}</label>
            <div class="col form-group">
                <el-select
                  class="select-primary"
                  name="role"
                  v-model="formDetails.status"
                >
                  <el-option
                    v-for="option in availableStatuses"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="option"
                  >
                  </el-option>
                </el-select>
            </div>
          </div>

          <!-- fare_groups select -->
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('operators.details.fare_group_id') }}</label>
            <div class="col form-group">
                <el-select
                  class="select-primary"
                  name="role"
                  v-model="formDetails.fare_group_id"
                >
                  <el-option
                    v-for="option in fareGroups"
                    class="select-primary"
                    :value="option.id"
                    :label="option.id"
                    :key="option.id"
                  >
                  </el-option>
                </el-select>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('operators.details.settings_stop_prefix') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'stop_prefix'"
                name="stop_prefix"
                v-model="formDetails.settings.stop_prefix">
              </base-input>
            </div>
          </div>

          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('operators.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";
import statuses from './operator_statuses'
import types from './operator_types'

export default {
  name: 'create-operator',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        id: '',
        name: '',
        fare_group_id: null,
        status: statuses[0],
        type: types[0],
        settings: {
          stop_prefix: ""
        }
      },
      modelValidations: {
        required: {
          required: true
        },
      },
      availableStatuses: statuses,
      availableTypes: types,
    }
  },

  computed: {
    ...mapState({
      updating: state => state.operator.updating,
      error: state => state.operator.error,
      fareGroups: state => state.fare_groups.data,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
    // getFareGroup() {
    //
    //   return this.fareGroups.forEach()
    // }
  },
  methods: {
    ...mapActions(['CreateOperator', 'LoadFareGroups']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      let id = this.formDetails.id;
      this.CreateOperator(this.formDetails).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('operators.create.createdNotification', this.formDetails),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.resetForm();
          this.$router.push({name: 'operator', params: {id: id}})
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        id: '',
        name: '',
        fare_group_id: '',
        status: statuses[0],
        type: types[0],
        settings: {
          stop_prefix: ""
        }
      };

      // reset validation errors
      this.$validator.reset()
    },
  },
  mounted() {
    if (this.$auth.can({fare_groups: 'read'}, 'permissions') && this.fareGroups.length <= 0) {
      // Load if not loaded.
      this.LoadFareGroups();
    }
  },
}
</script>
